import { AI_addUpdateConfiguration } from "APIs/notification";
import { AI_getUserData } from "APIs/user";
import { useCallback } from "react";
import { useAIEventHandler } from "../../node_modules/easy-redux-http-call/dist/index";

const NotificationSetup = () => {
  useAIEventHandler(AI_getUserData, {
    onSuccess: (data) => {
      if (data?.data?.status) {
        setupNotifications(data);
      }
    },
  });

  const requestNotificationPermission = useCallback(async (data) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY
          ),
        });
        // CALL THIS API USING PACKAGE (THIS IS ONLY FOR TESTING)
        AI_addUpdateConfiguration.call({
          urlParams: {
            employee_id: data?.data?.user?.employee_id,
          },
          params: {
            configuration: subscription,
          },
        });
        // await fetch(
        //   `http://localhost:8002/api/employee-push-notification/${data?.data?.user?.employee_id}`,
        //   {
        //     method: "POST",
        //     body: JSON.stringify({ configuration: subscription }),
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //   }
        // );
      } else {
        console.warn("Permission for notifications was denied");
      }
    } catch (error) {
      console.error("Failed to subscribe the user: ", error);
    }
  }, []);

  const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };
  const setupNotifications = async (data) => {
    if (
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window
    ) {
      await requestNotificationPermission(data);
    } else {
      console.warn("Push messaging or Notifications API is not supported");
    }
  };
  return null;
};

export default NotificationSetup;
